import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h2 } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import styled from 'styled-components';
const TopContainer = styled.section `
  display: grid;
  gap: 16px;
  margin-bottom: ${fluid(32, 40)};
  grid-auto-rows: auto;

  &:has(${ButtonStyles.Container}) {
    grid-template-columns: 1fr auto;
  }

  ${ButtonStyles.Container} {
    margin-bottom: auto;

    @media ${until(Device.TabletLarge)} {
      margin-top: auto;
    }

    @media ${from(Device.TabletLarge)} {
      grid-row: 1 / -1;
      grid-column: 2;
    }
  }
`;
const Title = styled.h2 `
  ${h2};

  max-width: 810px;
  margin-bottom: 0;

  @media ${until(Device.TabletLarge)} {
    margin: auto 0;
  }
`;
const Description = styled.div `
  ${contentStyles};

  max-width: 810px;

  @media ${until(Device.TabletLarge)} {
    grid-column: 1 / -1;
  }
`;
const CtaWrapper = styled.div `
  margin: ${fluid(32, 40)} 0 0;

  @media ${until(Device.MobileLarge)} {
    ${ButtonStyles.Container} {
      width: 100%;
      justify-content: center;

      &:not(:has(${ButtonStyles.IconWrapper})) {
        text-align: center;
      }
    }
  }
`;
const SectionInfoContainerStyles = {
    CtaWrapper,
    Description,
    Title,
    TopContainer,
};
export default SectionInfoContainerStyles;
